export default function DetalhesOleoAplicacao(){
    return(
        "Detalhes Oleo Aplicacao"
    )
}